import { useState, useEffect, useContext } from "react";
import { ReactReduxContext, useSelector, useDispatch } from 'react-redux';
import { setAudioPreview, setPositionPreview } from "../actions/index";

const usePreviewPlayer = (trackID, rootParent, index) => {
  const { store } = useContext(ReactReduxContext)
  const { getState } = store
  const dispatch = useDispatch();

  const isPreview = useSelector( state => (state.positionPreview && state.positionPreview.idParent === rootParent && state.positionPreview.position === index) );

  const [player] = useState(document.getElementById(`preview_audio`));
  const [audio, setAudio] = useState(null);
  const [isPlaying, setIsPlaying] = useState(isPreview); /*isPreviewPlay*/
  const [position, setPosition] = useState(null);
  const [idParent, setIdParent] = useState(null);

  useEffect(() => {
    return () => { // Kill the preview out of the context
      const state = getState();
      if (state && state.positionPreview.idParent === idParent && state.positionPreview.position === position) {
        player.pause();
        dispatch(setPositionPreview(null, 0));
      } }
  }, [position, dispatch, getState, idParent, player]);

  const setPlay = (state) => {
    setIsPlaying(state);
    if (state) {
      player.play();
    } else {
      player.pause();
    }
  }

  const backward = (e) => {
    player.currentTime -= 10;
    player.play();
    if (e) { e.stopPropagation(); } // To avoid row selection

  }
  const forward = (e) => {
    player.currentTime += 10;
    if (player.currentTime < player.duration) {
      player.play();
    } else {
      kill();
    }
    if (e) { e.stopPropagation(); } // To avoid row selection
  }

  const reset = () => {
    if (player) {
      player.pause();
      player.currentTime = 0;
    }
  }

  const play = (e) => {
    const state = getState();

    dispatch(setPositionPreview(rootParent, index));
    setIdParent(rootParent);
    setPosition(index);

    if (!audio || audio !== state.audioPreview) {
      setIsPlaying(true);
      reset();

      // PREVIEW SAMPLE
      state.api.getFromApi(`/catalog/tracks/${trackID}`, false).then( res => {
        dispatch(setAudioPreview(res.data.sample_url));
        setAudio(res.data.sample_url);
        player.play();
      }).catch( e => console.log(`error`, e) );

    } else {
      setPlay(true);
    }
    if (e) { e.stopPropagation(); } // To avoid row selection
  }

  const pause = (e) => {
    setPlay(false);
    if (e) { e.stopPropagation(); } // To avoid row selection
  }

  const kill = () => {
    pause();
    dispatch(setPositionPreview(null, 0));
  }

  const previewPlayer = { player, play, pause, backward, forward, isPlaying, position, setPosition, kill, idParent, isPreview };
  return previewPlayer;
}

export default usePreviewPlayer;
